.links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px 18px;
  margin-top: 8px;
  padding: 0 var(--pad);
}

.link {
  padding: 4px 0;
  font-size: 12px;
  color: var(--muted);
  text-decoration: underline;
  text-underline-offset: 3px;
  background: none;
  border: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* Документа ещё нет — ссылка видна, но вести ей некуда. */
.link:disabled {
  opacity: 0.5;
  cursor: default;
}
